import { render, staticRenderFns } from "./Item_TD.vue?vue&type=template&id=d1af560a&scoped=true"
import script from "./Item_TD.vue?vue&type=script&lang=js"
export * from "./Item_TD.vue?vue&type=script&lang=js"
import style0 from "./Item_TD.vue?vue&type=style&index=0&id=d1af560a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1af560a",
  null
  
)

export default component.exports